"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArchiveAfterXDaysValid = void 0;
const common_1 = require("../../consts/common");
const common_2 = require("../common");
const isArchiveAfterXDaysValid = (value) => {
    if (!(0, common_2.isNumeric)(value)) {
        return false;
    }
    if (value < common_1.MIN_ALLOWED_ARCHIVE_AFTER_X_DAYS || value > common_1.MAX_ALLOWED_ARCHIVE_AFTER_X_DAYS) {
        return false;
    }
    return true;
};
exports.isArchiveAfterXDaysValid = isArchiveAfterXDaysValid;
